import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";


@Injectable({
    providedIn: 'root'
  })
  export class Base {

    private farm = new BehaviorSubject({});

    private fieldImage = new BehaviorSubject({});
  
    private image = new BehaviorSubject({});
  
    private filter = new BehaviorSubject({});
  
    private vcFilter = new BehaviorSubject({});
  
    public hasError = new BehaviorSubject<boolean>(false);
    hasError$ = this.hasError.asObservable();
  
    public errorMessage = new BehaviorSubject<string>("");
    errorMessage$ = this.errorMessage.asObservable();

    public language;

    public menuIsOpen = new BehaviorSubject<boolean>(false);
    public menuIsOpen$ = this.menuIsOpen.asObservable();

    public silenceOpen() {
      this.menuIsOpen.next(true);
    }
    public silenceClose() {
      this.menuIsOpen.next(false);
    }

    setLanguage(language: string) {
      this.language = language;
    }
  
    setFarm(farmId: number, farmName: string) {
      this.farm.next({ farmId: farmId, farmName: farmName });
    }
  
    resetFarm() {
      this.farm = new BehaviorSubject({});
    }
  
    fetchFarm(): Observable<any> {
      return this.farm.asObservable();
    }
  
    setAnalysis(histories, images, path, polygons) {
      this.image.next({ histories, images, path, polygons });
    }
  
    resetAnalysis() {
      this.image = new BehaviorSubject({});
    }
  
    fetchAnalysis(): Observable<any> {
      return this.image.asObservable();
    }
  
    setFieldAnalysis(fieldHistories, fieldImages, fieldPath) {
      this.fieldImage.next({ fieldHistories, fieldImages, fieldPath });
    }
  
    resetFieldAnalysis() {
      this.fieldImage = new BehaviorSubject({});
    }
  
    fetchFieldAnalysis(): Observable<any> {
      return this.fieldImage.asObservable();
    }
  
    setFilter(filter) {
      this.filter.next({ filter });
    }
  
    fetchFilter(): Observable<any> {
      return this.filter.asObservable();
    }
  
    resetFilter() {
      this.filter = new BehaviorSubject({});
    }
  
    setVcFilter(vcFilter) {
      this.vcFilter.next({ vcFilter });
    }
  
    fetchVcFilter(): Observable<any> {
      return this.vcFilter.asObservable();
    }
    
  }  